'use strict';

let module = {};

let routes = function ($stateProvider, baseState) {

    require('project/crud/clerk-ledger/routes.js').default.routes($stateProvider, '' + baseState + '');

    // ** Related items navigation without leaving fiscal year side menu **

    $stateProvider

        .state(baseState + '.clerk-ledgers.existing.edit.overview', {
            url: "/overview",
            template: require("crud/clerk-ledger/steps/overview.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-related-settings', {
            url: "/ledger-related-settings",
            template: require("./ledger-related-settings.html"),
            data: {pageTitle: 'ledger-related-settings'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reconcile', {
            url: "/reconcile",
            template: require("crud/clerk-ledger/steps/reconcile.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'reconcile';
                },
            },
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-ledger-contents', {
            url: "/inspect-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'reconcile';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Showing ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-imported-ledger-contents', {
            url: "/inspect-imported-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'inspect-imported';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Showing imported ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries-overview', {
            url: "/ledger-entries-overview",
            template: require("crud/clerk-ledger/steps/ledger-entries.overview.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'categorize';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Showing ledger entries overview',
                hideFormTop: false,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.group-imported-ledger-contents', {
            url: "/group-imported-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'group-imported-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Set groups for imported ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.classify-imported-ledger-contents', {
            url: "/classify-imported-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'classify-imported-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.clerk_ledger_entry_category_id ASC, ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Set types & VAT for imported ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-vat-related-ledger-contents', {
            url: "/inspect-vat-related-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'inspect-vat-related-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = 'empty';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry_ClerkLedgerEntryRow_sum_abs_amount DESC';
                },
            },
            data: {
                pageTitle: 'Showing VAT-related ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.document-vat-related-ledger-contents', {
            url: "/document-vat-related-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'document-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = 'empty';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry_ClerkLedgerEntryRow_sum_abs_amount DESC';
                },
            },
            data: {
                pageTitle: 'Add receipts and other supporting documents to VAT-related ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-vat-related-figures-to-report', {
            url: "/inspect-vat-related",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'inspect-vat-related-figures-to-report';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = '1';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal DESC';
                },
            },
            data: {
                pageTitle: 'Showing VAT-related figures to report',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-the-largest-ledger-contents', {
            url: "/inspect-the-largest-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'inspect-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = 'empty';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry_ClerkLedgerEntryRow_sum_abs_amount DESC';
                },
            },
            data: {
                pageTitle: 'Showing ledger contents starting with the largest and most important entries',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reconcile-ledger-contents-with-bank-account-balances', {
            url: "/reconcile-ledger-contents-with-bank-account-balances",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'reconcile';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Showing ledger contents in relation to bank account balances',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reconcile-ledger-contents-with-imported-ledger-contents', {
            url: "/reconcile-ledger-contents-with-imported-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'reconcile';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = null;
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                },
            },
            data: {
                pageTitle: 'Showing re-created ledger contents in relation to imported ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.document-ledger-contents', {
            url: "/document-ledger-contents",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'document-ledger-contents';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = 'empty';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry_ClerkLedgerEntryRow_sum_abs_amount DESC';
                },
            },
            data: {
                pageTitle: 'Add receipts and other supporting documents to ledger contents',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.inspect-income-tax-related-figures-to-report', {
            url: "/inspect-income-tax-related-figures-to-report",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'inspect-income-tax-related-figures-to-report';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerEntry_vat_related_for_clerk_ledger_id = null;
                    routeBasedContentFilters.ClerkLedgerEntry_has_relevant_figures_to_report = '1';
                    routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal DESC';
                },
            },
            data: {
                pageTitle: 'Showing numbers to report',
                hideFormTop: true,
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entry-types', {
            url: "/ledger-entry-types",
            template: require("crud/clerk-ledger/steps/ledger-entry-types.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions', {
            abstract: true,
            url: "/transactions",
            template: require("crud/clerk-ledger/steps/transactions.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.tax-entities', {
            url: "/tax-entities",
            template: require("crud/clerk-ledger/steps/transactions.tax-entities.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.accounts', {
            url: "/accounts",
            template: require("crud/clerk-ledger/steps/transactions.accounts.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.account-balances', {
            url: "/account-balances",
            template: require("crud/clerk-ledger/steps/transactions.account-balances.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions', {
            abstract: true,
            url: "/transactions",
            template: require("crud/clerk-ledger/steps/transactions.transactions.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.import', {
            url: "/import",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.import.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepMetadata: {
                    stepCaption: 'Transactions - Import',
                    stepReference: '',
                },
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.parse-imported', {
            url: "/parse-imported",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.parse-imported.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - Parse imported',
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.reality-check', {
            url: "/reality-check",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.reality-check.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - reality-check',
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.assign-sending-and-receiving-parties', {
            url: "/assign-sending-and-receiving-parties",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.assign-sending-and-receiving-parties.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - assign-sending-and-receiving-parties',
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.ledger-entry-types', {
            url: "/",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.ledger-entry-types.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - ledger-entry-types',
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.fine-tune-ledger-accounts', {
            url: "/fine-tune-ledger-accounts",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.fine-tune-ledger-accounts.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - fine-tune-ledger-accounts',
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.transactions.transactions.calculate-vat-amounts', {
            url: "/calculate-vat-amounts",
            template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.calculate-vat-amounts.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Transactions - calculate-vat-amounts',
            }
        })

        /*
         .state(baseState + '.clerk-ledgers.existing.edit.transactions.tax-regions', {
         url: "/tax-regions",
         onEnter: function () {
         },
         data: {pageTitle: 'Edit Fiscal Year'}
         })
         */

        .state(baseState + '.clerk-ledgers.existing.edit.business-events', {
            abstract: true,
            url: "/business-events",
            template: require("crud/clerk-ledger/steps/business-events.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.business-events.overview', {
            url: "/overview",
            template: require("crud/clerk-ledger/steps/business-events.overview.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        /*
         .state(baseState + '.clerk-ledgers.existing.edit.business-events.sent-yet-unpaid-invoices', {
         url: "/sent-yet-unpaid-invoices",
         template: require("crud/clerk-ledger/steps/business-events.sent-yet-unpaid-invoices.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })

         .state(baseState + '.clerk-ledgers.existing.edit.business-events.received-yet-unpaid-invoices', {
         url: "/received-yet-unpaid-invoices",
         template: require("crud/clerk-ledger/steps/business-events.received-yet-unpaid-invoices.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })

         .state(baseState + '.clerk-ledgers.existing.edit.business-events.subscriptions', {
         url: "/subscriptions",
         template: require("crud/clerk-ledger/steps/business-events.subscriptions.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })

         .state(baseState + '.clerk-ledgers.existing.edit.business-events.trips', {
         url: "/trips",
         template: require("crud/clerk-ledger/steps/business-events.trips.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })

         .state(baseState + '.clerk-ledgers.existing.edit.business-events.travel-claims', {
         url: "/travel-claims",
         template: require("crud/clerk-ledger/steps/business-events.travel-claims.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })
         */

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries', {
            abstract: true,
            url: "/ledger",
            template: require("crud/clerk-ledger/steps/ledger-entries.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerEntry_columns_by_step = 'document-ledger-entries';
                },
            },
            data: {
                pageTitle: 'Edit Fiscal Year',
                hideFormTop: true,
            },
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-accounts', {
            url: "/accounts",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-accounts.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-account-balances', {
            url: "/account-balances",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-account-balances.html"),
            data: {
                pageTitle: 'Ledger account balances relevant for the current ledger',
                hideFormTop: false,
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_columns_by_step = 'ledger.ledger-account-balances';
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_hide_source_relation = 'attributes.clerkLedger.id';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerAccountBalance_relevant_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerAccountBalance_clerkLedgerAccount_clerk_tax_entity_id = $stateParams.activeClerkTaxEntityId;
                    // Careful here, since backend runs ledgerAccountBalances() on the query, special consideration needs to be taken as to how it behaves with additional orderBy() statements
                    routeBasedContentFilters.ClerkLedgerAccountBalance_order = 'ClerkLedgerAccountBalance.date DESC'; // , ClerkLedgerAccount.accounting_reference ASC, ClerkLedgerAccountBalance.id ASC
                },
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.imported-ledger-account-balances', {
            url: "/imported-account-balances",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-account-balances.html"),
            data: {
                pageTitle: 'Imported ledger account balances',
                hideFormTop: true,
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_columns_by_step = 'ledger.ledger-account-balances';
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_hide_source_relation = 'attributes.clerkLedger.id';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerAccountBalance_relevant_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerAccountBalance_clerkLedgerAccount_clerk_tax_entity_id = $stateParams.activeClerkTaxEntityId;
                    // Careful here, since backend runs ledgerAccountBalances() on the query, special consideration needs to be taken as to how it behaves with additional orderBy() statements
                    routeBasedContentFilters.ClerkLedgerAccountBalance_order = 'ClerkLedgerAccountBalance.date DESC'; // , ClerkLedgerAccount.accounting_reference ASC, ClerkLedgerAccountBalance.id ASC
                },
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entry-types', {
            url: "/entry-types",
            template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entry-types.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.settings', {
            url: "/settings",
            template: require("crud/clerk-ledger/steps/ledger-entries.settings.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                stepCaption: 'Configure ledger',
                hideFormTop: false,
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_columns_by_step = 'ledger.ledger-account-balances';
                    routeBasedVisibilitySettings.ClerkLedgerAccountBalance_hide_source_relation = 'attributes.clerkLedger.id';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerAccountBalance_relevant_for_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                    routeBasedContentFilters.ClerkLedgerAccountBalance_clerkLedgerAccount_clerk_tax_entity_id = $stateParams.activeClerkTaxEntityId;
                    // Careful here, since backend runs ledgerAccountBalances() on the query, special consideration needs to be taken as to how it behaves with additional orderBy() statements
                    routeBasedContentFilters.ClerkLedgerAccountBalance_order = 'ClerkLedgerAccountBalance.date DESC'; // , ClerkLedgerAccount.accounting_reference ASC, ClerkLedgerAccountBalance.id ASC
                },
            }
        })

    ;

    var views = {};
    views[''] = {
        template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entries.html"),
    };
    /*
    TODO: Restore current classification / item logic but then via components instead of this madness

    views['currentClassificationForm@' + baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries'] = {
        controller: function ($scope, $state, clerkLedgerEntries) {
            $scope.clerkLedgerEntries = clerkLedgerEntries;
        },
        template: require("crud/clerk-ledger-entry/current-classification-form.html"),
    };
    views['currentClassification@' + baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries'] = {
        template: '<div class="alert alert-info">Select a ledger entry to begin</div>'
    };

    $stateProvider

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries', {
            url: "/entries",
            views: views,
            data: {
                pageTitle: 'Edit Fiscal Year',
                hideFormTop: true
            }
        })

    ;

    var views = {};
    views['currentClassification@' + baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries'] = {
        controller: "currentClerkLedgerEntryClassificationController",
        template: require("crud/clerk-ledger-entry/current-classification.html"),
    };
    views['currentClassificationStep@' + baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries.current-item'] = {
        controller: function (routeBasedContentFilters) {
            this.uiOnParamsChanged = function (changedParams, $transition$) {
                console.log('routes.uiOnParamsChanged', changedParams, $transition$);
                if (changedParams.clerkLedgerEntryId) {
                    routeBasedContentFilters.ClerkLedgerEntryRow_clerk_ledger_entry_id = changedParams.clerkLedgerEntryId;
                }
            };
        },
        template: require("crud/clerk-ledger-entry/classification-steps/attributes.html"),
    };


    $stateProvider

        .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entries.current-item', {
            url: "/:clerkLedgerEntryId",
            params: {clerkLedgerEntryId: {dynamic: true}},
            resolve: {
                setRouteBasedContentFiltersLevel2: /*@ngInject* / function (routeBasedContentFilters, setRouteBasedContentFiltersLevel1A, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntryRow_clerk_ledger_entry_id = $stateParams.clerkLedgerEntryId;
                },
                currentClerkLedgerEntry: /*@ngInject* / function (dataEnvironmentParam, $stateParams, clerkLedgerEntryResource, clerkLedgerEntries) {
                    return clerkLedgerEntries.loadItem($stateParams.clerkLedgerEntryId);
                },
            },
            views: views,
            data: {pageTitle: 'Edit Fiscal Year'}
        })
    */

    $stateProvider

        /*
         .state(baseState + '.clerk-ledgers.existing.edit.ledger-entries.ledger-entry-rows', {
         url: "/ledger-entry-rows",
         template: require("crud/clerk-ledger/steps/ledger-entries.ledger-entry-rows.html"),
         data: {pageTitle: 'Edit Fiscal Year'}
         })
         */

        .state(baseState + '.clerk-ledgers.existing.edit.archive-fiscal-year', {
            url: "/archive-fiscal-year",
            template: require("crud/clerk-ledger/steps/archive-fiscal-year.html"),
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reports', {
            abstract: true,
            url: "/reports",
            template: require("crud/clerk-ledger/steps/reports.html"),
            data: {
                pageTitle: 'Edit Fiscal Year',
                hideFormTop: true
            }
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reports.balance-sheet', {
            url: "/balance-sheet",
            onEnter: function () {
            },
            data: {pageTitle: 'Edit Fiscal Year'}
        })

        .state(baseState + '.clerk-ledgers.existing.edit.reports.income-statement', {
            url: "/income-statement",
            onEnter: function () {
            },
            data: {pageTitle: 'Edit Fiscal Year'}
        })

    ;

};

/*
 module.config(function ($stateProvider) {
 routes($stateProvider, 'root.api-endpoints.existing');
 });
 */

/*
 module.config(function ($stateProvider) {
 routes($stateProvider, 'root.api-endpoints.existing.books.optionally-by-clerk-ledger-deliverable.just-browsing');
 });
 */

module.routes = routes;

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-ledger/customized-routes.js